import { Prefill } from '@library/formBuilder/prefill';
import type { AtomModel } from '@models/atom.model';
import type { CheckBoxData } from '@stratumn/studio-shared';

type Props = {
  atom: AtomModel<CheckBoxData>;
};

export const CheckBoxModal = ({ atom }: Props) => (
  <>
    <Prefill atom={atom} />
  </>
);
